import { render, staticRenderFns } from "./SaveWidget.vue?vue&type=template&id=45db273e&scoped=true"
import script from "./SaveWidget.vue?vue&type=script&lang=js"
export * from "./SaveWidget.vue?vue&type=script&lang=js"
import style0 from "./SaveWidget.vue?vue&type=style&index=0&id=45db273e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45db273e",
  null
  
)

export default component.exports